import { useQuery } from "@tanstack/react-query";
import { TemporalWorkflow } from "@ternary/api-lib/core/types";
import UError from "unilib-error";
import { ANALYTICS_QUERY_GC_TIME } from "../../constants";
import { useTemporalApiClient } from "../../context/TemporalApiClientProvider";
import { UseQueryOptions, UseQueryResult } from "../../lib/react-query";
import queryKeys from "./queryKeys";

export function useGetBillingV3WorkflowByTenantID(
  tenantID: string,
  options?: UseQueryOptions<TemporalWorkflow, UError>
): UseQueryResult<TemporalWorkflow, UError> {
  const client = useTemporalApiClient();

  return useQuery({
    queryKey: queryKeys.billingV3Workflow(tenantID),
    queryFn: () => client.getWorkflowByTenantID(tenantID),
    gcTime: ANALYTICS_QUERY_GC_TIME,
    ...options,
  });
}
